import * as React from 'react'
import type { SVGProps } from 'react'
import type { Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClock = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 12 12'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='{props.color} #000'
      fillOpacity={0.6}
      d='M10.167 5.999a4.166 4.166 0 1 0-8.333 0 4.166 4.166 0 0 0 8.333 0m.833 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0'
    />
    <path
      fill='{props.color} #000'
      fillOpacity={0.6}
      d='M5.583 4.334a.417.417 0 0 1 .834 0v1.429l1.4.826a.417.417 0 0 1-.424.718l-1.605-.948-.205-.121z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgClock)
export default ForwardRef
